import { VueModule } from '@Foundation/utilities';
import Modal from './code/Scripts/components/modal.vue';

export default VueModule({
  components: {
    Modal
  }
});
